export enum ImsCostingMethod {
  WeightedAverage = "weighted_average",
  Fifo = "fifo",
}
